import http from '@/api/http'
import { serializeArrayParams } from '@/utils/api'

import {
  DashboardPredictionYearsResponse,
  DashboardCensusYearsResponse,
  DashboardCitiesByStatePayload,
  DashboardCitiesByStateResponse,
  DashboardSchoolsByCityPayload,
  DashboardSchoolsByCityResponse,
  DashboardYearGradesResponse,
  DashboardPredictionPayload,
  DashboardPredictionResponse,
  DashboardPredictionEducationStagesPayload,
  DashboardPredictionEducationStagesResponse,
  DashboardCensusPayload,
  DashboardCensusResponse,
  DashboardCensusEducationStagesPayload,
  DashboardCensusEducationStagesResponse,
  DashboardComparativePayload,
  DashboardComparativeResponse,
  DashboardComparativeEducationStagesPayload,
  DashboardComparativeEducationStagesResponse,
  DashboardPanoramaPayload,
  DashboardPanoramaOverviewResponse,
  DashboardPanoramaStatesResponse,
} from './types'

export const dashboardPredictionYears =
  async (): Promise<DashboardPredictionYearsResponse> => {
    const response = await http.get<DashboardPredictionYearsResponse>(
      '/dashboard/prediction/years/'
    )

    return response.data
  }

export const dashboardCensusYears =
  async (): Promise<DashboardCensusYearsResponse> => {
    const response = await http.get<DashboardCensusYearsResponse>(
      '/dashboard/census/years/'
    )

    return response.data
  }

export const dashboardCitiesByState = async (
  payload: DashboardCitiesByStatePayload
): Promise<DashboardCitiesByStateResponse> => {
  const response = await http.get<DashboardCitiesByStateResponse>(
    '/dashboard/cities/',
    {
      params: serializeArrayParams(payload),
    }
  )

  return response.data
}

export const dashboardSchoolsByCity = async (
  payload: DashboardSchoolsByCityPayload
): Promise<DashboardSchoolsByCityResponse> => {
  const response = await http.get<DashboardSchoolsByCityResponse>(
    '/dashboard/schools/',
    {
      params: serializeArrayParams(payload),
    }
  )

  return response.data
}

export const dashboardYearGrades =
  async (): Promise<DashboardYearGradesResponse> => {
    const response = await http.get<DashboardYearGradesResponse>(
      '/dashboard/year-grades/'
    )

    return response.data
  }

export const dashboardPrediction = async (
  payload: DashboardPredictionPayload
): Promise<DashboardPredictionResponse> => {
  const response = await http.get<DashboardPredictionResponse>(
    '/dashboard/prediction/',
    {
      params: serializeArrayParams(payload),
    }
  )

  return response.data
}

export const dashboardPredictionEducationStages = async (
  payload: DashboardPredictionEducationStagesPayload
): Promise<DashboardPredictionEducationStagesResponse> => {
  const response = await http.get<DashboardPredictionEducationStagesResponse>(
    '/dashboard/prediction/education-stages/',
    {
      params: serializeArrayParams(payload),
    }
  )

  return response.data
}

export const dashboardCensus = async (
  payload: DashboardCensusPayload
): Promise<DashboardCensusResponse> => {
  const response = await http.get<DashboardCensusResponse>(
    '/dashboard/census/',
    {
      params: serializeArrayParams(payload),
    }
  )

  return response.data
}

export const dashboardCensusEducationStages = async (
  payload: DashboardCensusEducationStagesPayload
): Promise<DashboardCensusEducationStagesResponse> => {
  const response = await http.get<DashboardCensusEducationStagesResponse>(
    '/dashboard/census/education-stages/',
    {
      params: serializeArrayParams(payload),
    }
  )

  return response.data
}

export const dashboardComparative = async (
  payload: DashboardComparativePayload
): Promise<DashboardComparativeResponse> => {
  const response = await http.get<DashboardComparativeResponse>(
    '/dashboard/comparative/',
    {
      params: serializeArrayParams(payload),
    }
  )

  return response.data
}

export const dashboardComparativeEducationStages = async (
  payload: DashboardComparativeEducationStagesPayload
): Promise<DashboardComparativeEducationStagesResponse> => {
  const response = await http.get<DashboardComparativeEducationStagesResponse>(
    '/dashboard/comparative/education-stages/',
    {
      params: serializeArrayParams(payload),
    }
  )

  return response.data
}

export const dashboardPanoramaOverview = async (
  payload: DashboardPanoramaPayload
): Promise<DashboardPanoramaOverviewResponse> => {
  const response = await http.get<DashboardPanoramaOverviewResponse>(
    '/dashboard/panorama/overview/',
    {
      params: serializeArrayParams(payload),
    }
  )

  return response.data
}

export const dashboardPanoramaStates = async (
  payload: DashboardPanoramaPayload
): Promise<DashboardPanoramaStatesResponse> => {
  const response = await http.get<DashboardPanoramaStatesResponse>(
    '/dashboard/panorama/states/',
    {
      params: serializeArrayParams(payload),
    }
  )

  return response.data
}
